"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "TableBody", {
  enumerable: true,
  get: function get() {
    return _TableBody["default"];
  }
});
Object.defineProperty(exports, "TableCell", {
  enumerable: true,
  get: function get() {
    return _TableCell["default"];
  }
});
Object.defineProperty(exports, "TableHead", {
  enumerable: true,
  get: function get() {
    return _TableHead["default"];
  }
});
Object.defineProperty(exports, "TableHeaderCell", {
  enumerable: true,
  get: function get() {
    return _TableHeaderCell["default"];
  }
});
Object.defineProperty(exports, "TableRow", {
  enumerable: true,
  get: function get() {
    return _TableRow["default"];
  }
});
exports["default"] = void 0;

var _propTypes = require("prop-types");

var _react = _interopRequireDefault(require("react"));

var _styledComponents = require("styled-components");

var _Table = _interopRequireDefault(require("./Table.context"));

var _Table2 = require("./Table.styles");

var _TableBody = _interopRequireDefault(require("./TableBody/TableBody.index"));

var _TableCell = _interopRequireDefault(require("./TableCell/TableCell.index"));

var _TableHead = _interopRequireDefault(require("./TableHead/TableHead.index"));

var _TableHeaderCell = _interopRequireDefault(require("./TableHeaderCell/TableHeaderCell.index"));

var _TableRow = _interopRequireDefault(require("./TableRow/TableRow.index"));

var Table = function Table(_ref) {
  var children = _ref.children,
      size = _ref.size,
      type = _ref.type;
  return /*#__PURE__*/_react["default"].createElement(_Table["default"].Provider, {
    value: {
      size: size,
      type: type
    }
  }, /*#__PURE__*/_react["default"].createElement(_Table2.StyledTable, {
    type: type,
    size: size
  }, children));
};

var tableSection = (0, _propTypes.shape)({
  type: (0, _propTypes.oneOf)([_TableHead["default"], _TableBody["default"]])
});
Table.defaultProps = {
  size: 'normal',
  type: 'standard'
};
Table.propTypes = {
  /** Defines table row size. */
  size: (0, _propTypes.oneOf)(['normal', 'large']),

  /** Defines the table type */
  type: (0, _propTypes.oneOf)(['standard', 'stripes']),

  /** Table children (Head and Body)  */
  children: (0, _propTypes.oneOfType)([(0, _propTypes.arrayOf)(tableSection), tableSection]).isRequired
};
Table.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Table",
  "props": {
    "size": {
      "defaultValue": {
        "value": "'normal'",
        "computed": false
      },
      "description": "Defines table row size.",
      "type": {
        "name": "enum",
        "value": [{
          "value": "'normal'",
          "computed": false
        }, {
          "value": "'large'",
          "computed": false
        }]
      },
      "required": false
    },
    "type": {
      "defaultValue": {
        "value": "'standard'",
        "computed": false
      },
      "description": "Defines the table type",
      "type": {
        "name": "enum",
        "value": [{
          "value": "'standard'",
          "computed": false
        }, {
          "value": "'stripes'",
          "computed": false
        }]
      },
      "required": false
    },
    "children": {
      "description": "Table children (Head and Body)",
      "type": {
        "name": "union",
        "value": [{
          "name": "arrayOf",
          "value": {
            "name": "custom",
            "raw": "tableSection"
          }
        }, {
          "name": "custom",
          "raw": "tableSection"
        }]
      },
      "required": true
    }
  }
};

var _default = (0, _styledComponents.withTheme)(Table);

exports["default"] = _default;